<div [formGroup]="formGroup" class="control control--input control--checkbox-group" [hidden]="hidden">
  <div *ngIf="model.hasLabel" class="control__header">
    <label class="control__header__label" [for]="model.key" [title]="model.label">{{ model.label }}</label>
    <div class="control__header__error" *ngIf="hasError" [title]="error">{{ error }}</div>
  </div>
  <div class="control__header">
    <app-button
      [disabled]="!enableToggleButton"
      classes="small"
      [text]="toggleButtonText"
      (onClick)="toggleAll($event)">
    </app-button>
  </div>
  <p-listbox
    [hidden]="!hasOptions"
    [options]="options"
    [multiple]="true"
    [checkbox]="true"
    [filter]="false"
    [showToggleAll]="false"
    [optionLabel]="optionText"
    [styleClass]="classes"
    dataKey="value"
    (onChange)="onChange.emit($event); onInput.emit($event);"
    [id]="model.key"
    [formControlName]="model.key"
    [(ngModel)]="model.selectedOptions">
  </p-listbox>
  <div *ngIf="!hasOptions" class="text--danger">Information Not Available.</div>
</div>
